<div class="wrapper flex">
  <app-sidebar></app-sidebar>
  <div
    class="content flex column grow1"
    [class.content--workflow-immersive]="immersiveWorkflow | async"
  >
    @if ((immersiveWorkflow | async) === false) {
      <app-header></app-header>
    }
    <div
      class="top-margin-15 grow1"
      [class.top-margin-15--workflow-immersive]="immersiveWorkflow | async"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
